export default function replaceUserName(input: string, name: string) {
  return input.replace(/{([^{}]*)}/g, function (_, p) {
    if (p.toLowerCase().includes("name")) {
      return name;
    } else {
      return p;
    }
  });
}
